import React from 'react';
import PropTypes from 'prop-types';
import VODCard from './vodCard';

const propTypes = {
  vod: PropTypes.object.isRequired,
  onClickMore: PropTypes.func,
  onClickVOD: PropTypes.func,
  key: PropTypes.number
}

const defaultProps = {
  onClickMore: null,
  onClickVOD: null,
  vod: null,
}

class VODListItem extends React.Component<propTypes> {
  render() {
    const { vod, onClickMore, onClickVOD } = this.props
    const contentTitle = Object.keys(vod)[0]
    const listArray = vod[contentTitle]

    return (
      <div className="list-body">
        <div className="title-container">
          <div className="title">{contentTitle}</div>
          <div className="more" onClick={() => onClickMore(contentTitle)}>
            더보기 &gt;
          </div>
        </div>
        <ul className="hs">
          {listArray.map((content, t) => (
            <VODCard key={t} type="normal" content={content} onClickVOD={onClickVOD} />
          ))}
        </ul>
      </div>
    )
  }
}

VODListItem.propsTypes = propTypes
VODListItem.defaultProps = defaultProps

export default VODListItem
